import { render, staticRenderFns } from "./FuelExpensesAdd.vue?vue&type=template&id=5fdf164c&scoped=true&"
import script from "./FuelExpensesAdd.vue?vue&type=script&lang=js&"
export * from "./FuelExpensesAdd.vue?vue&type=script&lang=js&"
import style0 from "./FuelExpensesAdd.vue?vue&type=style&index=0&id=5fdf164c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf164c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
